import React from "react";

import { Switch, Route } from "react-router-dom";
import FinanceProfile from "./FinanceProfile";
import StaffContracts from "./contract-profile/ContractsProfile";

const Routes = () => {
  const basePath = "/mis";
  return (
    <Switch>
      <Route
        path={`${basePath}/staff/:sid/profile/salary`}
        render={(p) => <FinanceProfile {...p} />}
      />
      <Route
        path={`${basePath}/staff/:sid/profile/contracts`}
        render={(p) => <StaffContracts {...p} />}
      />
    </Switch>
  );
};

export default Routes;
